import { WhmStack, WhmTypography } from "@securitize/reactjs-whm";
import Snackbar, { SnackbarProvider } from "../shared/Snackbar";
import { Translate } from "../Translation/Translate";
import translationKeys from "../../contexts/I18nContext/translationKeys";
import PortfolioTopSectionContainer from "./components/PortfolioTopSectionContainer";
import PortfolioPromotionCards from "./components/PromotionCards";
import EntityOnboardingCardContainer from "../shared/onboarding/EntityOnboardingCardContainer";
import useUserInfo from "../../hooks/useUserInfo";
import Assets from "./components/Assets";
import { RedirectAuthenticatedProvider } from "../../contexts/RedirectAuthenticatedContext";
import { shouldShowEntityOnboarding } from "../../helpers/portfolio";

export default function Portfolio() {
  const { verificationStatus, investorType, hasBdAccess } = useUserInfo();
  const showOnboarding = shouldShowEntityOnboarding(
    verificationStatus,
    investorType,
  );

  return (
    <SnackbarProvider>
      <RedirectAuthenticatedProvider>
        <WhmStack sx={{ padding: "0", gap: "16px" }}>
          <WhmTypography variant="h1">
            <Translate translationKey={translationKeys.PORTFOLIO_TITLE} />
          </WhmTypography>
          {showOnboarding ? (
            <EntityOnboardingCardContainer compressed={false} />
          ) : (
            <PortfolioTopSectionContainer />
          )}
          {hasBdAccess && <PortfolioPromotionCards />}
          <Assets />
        </WhmStack>
      </RedirectAuthenticatedProvider>
      <Snackbar />
    </SnackbarProvider>
  );
}
